import { makeStyles, MenuItem, Select, TextField } from "@material-ui/core";
import { useDataLayerValue } from "../../Reducer/DataLayer";

const DateFreeze = () => {
  const classes = useStyles();

  const [{ isFreeze, newsDate }, dispatch] = useDataLayerValue();

  return (
    <div className={classes.root}>
      <h5>News Date</h5>
      <TextField
        type="datetime-local"
        value={newsDate}
        onChange={(e) =>
          dispatch({
            type: "ADD_NEWSDATE",
            payload: { newsDate: e.target.value },
          })
        }
        variant="filled"
        className="w-75 mb-3"
      />

      {/* Freeze News */}
      <h5>Freeze News</h5>
      <Select
        value={isFreeze}
        onChange={(e) =>
          dispatch({
            type: "ADD_FREEZE",
            payload: { isFreeze: e.target.value },
          })
        }
        variant="filled"
        className="w-75"
      >
        <MenuItem value="" disabled>
          <em>Freeze News</em>
        </MenuItem>
        <MenuItem value={true}>True</MenuItem>
        <MenuItem value={false}>False</MenuItem>
      </Select>
    </div>
  );
};

export default DateFreeze;

const useStyles = makeStyles(() => ({
  root: {
    justifyContent: "center",
    alignItems: "center",
    // backgroundColor: "#f2f4fc",
    borderRadius: "0.5rem",
    display: "flex",
    flex: 1,
    flexDirection: "column",
  },
}));
